import { render } from "./DocumentView.vue?vue&type=template&id=72258ff0&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=72258ff0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72258ff0"]])

export default __exports__